import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography, Button, Paper, Grid, Divider } from '@material-ui/core';
import RoomIcon from '@material-ui/icons/Room';
import MailIcon from '@material-ui/icons/Mail';
import PhoneIcon from '@material-ui/icons/Phone';
import { useStyles } from './styles';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { insertActivityLog } from '../../actions';
import { getAppSource, getUserType, getPointPrivateLabel, isHEI } from '../../helpers';
import CustomBreadcrum from '../Breadcrum';
import {QuickAlert} from "../QuickAlert";
import { useHistory } from "react-router-dom";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

export function ReactOutToUs(props) {
  const history = useHistory();
  const classes = useStyles();
  const mytheme = useSelector(state => state.theme);
  const loanInfo = useSelector(state => state?.loanInfoReducer);
  const [quickPayStatus, setQuickPayStatus] = useState(false);
  const { privateLabelName, address, customerCareNumber, lendingNumber, customerCareTime, lendingNumberTime } = mytheme;
  const theme = useTheme();
  const mediaQuery = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (props?.contactUs) {
      setTimeout(() => {
        window.scrollTo({ top: getPointPrivateLabel() ? 250 : 450, left: 0, behavior: 'smooth' });
      }, 1000);
    }
  }, [props?.contactUs]);

  const sendActivityData = async (message) => {
    const data = {
      accountNumber: Cookies.get("selectedAccount"),
      activityCode: "UAL205",
      activityStatus: "Success",
      action: "SupportHelp",
      controller: "SupportTicket",
      apiName: "SupportTicket",
      activityRemark: message,
      privateLabelUrl: Cookies.get("privateLabelUrl"),
      ipAddress: Cookies.get('publicIp'),
      browser: Cookies.get("browser"),
      appSource: getAppSource(),
      userType: getUserType(),
      userName: "",
    };
    await insertActivityLog(data);
  };

  const five9Status = () => {
    if ((loanInfo.isFive9 && Cookies.get('privateToken')) || !Cookies.get('privateToken')) {
      return true
    } else {
      return false
    }
  }

  const closeQuickPayPopup = () => {
    setQuickPayStatus(false)
  }

  const handleRoute = async () => {
    if (Cookies.get('privateToken')) {
      history.push(`/PaymentOption`);
    } else {
      setQuickPayStatus(true)
    }
  }

  return (
    <>
      <Box className={classes.breadcrum}>
        <CustomBreadcrum backPage="Home" backPageLink="/" activePage="Help" />
        <h1 className={classes.pageHeading} color="textPrimary" component='h4'> Have questions? Let us help you</h1>
      </Box>
      <Box className={classes.pageWrapper}>

        <Paper className={classes.card}>
          <Box className={classes.section}>
            <Typography className={classes.cardHeading}>
              <RoomIcon className={classes.icon} /> Mailing Addresses
            </Typography>
            <Grid container>
              <Grid md={3} sm={12} sx={12}>
                <Typography className={classes.cardHeading}>
                  General Correspondence Address:
                </Typography>
                <Typography dangerouslySetInnerHTML={{ __html: address }} className={classes.text} pl={6}></Typography>
              </Grid>
              { !isHEI() && 
              <>     
              {!mediaQuery && <Divider orientation="vertical" flexItem className={classes.verticalDivider} />}
              <Grid md={3} sm={12} sx={12}>
                {mediaQuery && <Box style={{ borderBottom: "1px solid #ccc", margin: "20px 0", width: '600px' }}></Box>}
                <Typography className={classes.cardHeading}>
                  Mail Your Payment to:
                </Typography>
                <Typography className={classes.text} pl={6}>{privateLabelName}</Typography>
                <Typography className={classes.text} pl={6}>PO Box 679002 Dallas,</Typography>
                <Typography className={classes.text} pl={6}>TX 75267-9002</Typography>
              </Grid>

              {!mediaQuery && <Divider orientation="vertical" flexItem className={classes.verticalDivider} /> }
              <Grid md={3} sm={12} sx={12}>
                {mediaQuery && <Box style={{ borderBottom: "1px solid #ccc", margin: "20px 0", width: '600px' }}></Box>}
                <Typography className={classes.cardHeading}>
                  Overnight Your Payment to:
                </Typography>
                <Typography className={classes.text} pl={6}>{privateLabelName}</Typography>
                <Typography className={classes.text} pl={6}>Lockbox Number 679002 1200</Typography>
                <Typography className={classes.text} pl={6}>E CAMPBELL RD STE 108 Richardson,</Typography>
                <Typography className={classes.text} pl={6}>TX 75081</Typography>
              </Grid> </>}
            </Grid>
            { !isHEI() && <Typography className={classes.links}> For additional payment options, <b className={classes.clickHere} onClick={() => handleRoute()}>click here</b> to visit the Payment Options page.</Typography>}
          </Box>
        </Paper>

        <Paper className={classes.card}>
          <Box className={classes.section}>
            <Typography className={classes.cardHeading}>
              <MailIcon className={classes.icon} /> Write to Us
            </Typography>
            <Typography className={classes.text}>
              Need assistance or have a question? You can reach our support team.
            </Typography>
            <Box className={classes.btnRow}>
              {loanInfo.isSupportTicket && !isHEI() && <Button
                variant="contained"
                className={classes.primaryBtn}
                color='primary'
                onClick={() => sendActivityData("Support Ticket - Clicked on help page hyperlink")}
                component={Link}
                to="/SupportTicket"
              >
                Create Ticket
              </Button>}
              {five9Status() && <Button
                variant="outlined"
                className={classes.primaryBtn}
                component={Link}
                to="/ContactUs"
              >
                Email Us
              </Button>}
            </Box>
          </Box>
        </Paper>

        <Paper className={classes.card}>
          <Box className={classes.section}>
            <Typography className={classes.cardHeading}>
              <PhoneIcon className={classes.icon} /> Call Us
            </Typography>

            <Grid container>
              {customerCareNumber &&
                <Grid md={5} >
                  <Box mt={1}>
                    <Typography className={classes.cardHeading}>
                      Customer Care
                    </Typography>
                    <Typography className={classes.phoneNumber}>
                      <a href={`tel:${customerCareNumber}`} className={classes.link}>
                        {customerCareNumber}
                      </a>
                    </Typography>
                    <Typography className={classes.text} dangerouslySetInnerHTML={{ __html: customerCareTime }}></Typography>
                  </Box>
                </Grid>}
              {!mediaQuery && lendingNumber && <Divider orientation="vertical" flexItem className={classes.verticalDivider} />}
              {mediaQuery && lendingNumber && <Box style={{ borderBottom: "1px solid #ccc", margin: "20px 0", width: '600px' }}></Box>}

              {lendingNumber &&
                <Grid md={5}>
                  <Box mt={1}>
                    <Typography className={classes.cardHeading}>
                      Purchase. Refinance. Use your equity
                    </Typography>
                    <Typography className={classes.phoneNumber}>
                      <a href={`tel:${lendingNumber}`} className={classes.link}>
                        {lendingNumber}
                      </a>
                    </Typography>
                    <Typography className={classes.text} dangerouslySetInnerHTML={{ __html: lendingNumberTime }}>
                    </Typography>
                  </Box>
                </Grid>}
            </Grid>

          </Box>
        </Paper>

      </Box>
      <QuickAlert quickPay={quickPayStatus} closeQuickPayPopup={closeQuickPayPopup}/>
      
    </>
  );
}
